import { Select } from './';
import { mapModelOptions } from './common';

import React from 'react';
import PropTypes from 'prop-types';

const GenderSelect = ({ meta, ...props }) => (
  <Select
    options={mapModelOptions(meta.genders, 'title')}
    placeholder="Gender"
    {...props}
  />
);

GenderSelect.propTypes = {
  meta: PropTypes.shape({
    genders: PropTypes.array.isRequired,
  }).isRequired,
};

export default GenderSelect;



// WEBPACK FOOTER //
// ./src/components/GenderSelect.js